export const Work = [
  { label: "شاغل نیستم", value: "شاغل نیستم" },
  { label: "دانشجو هستم", value: "دانشجو" },
  { label: "شاغل آزاد", value: "شاغل آزاد" },
  { label: "کارمند رسمی", value: "کارمند رسمی" },
]

export const birthMonths = [
  { value: "01", label: "فروردین" },
  { value: "02", label: "اردیبهشت" },
  { value: "03", label: "خرداد" },
  { value: "04", label: "تیر" },
  { value: "05", label: "مرداد" },
  { value: "06", label: "شهریور" },
  { value: "07", label: "مهر" },
  { value: "08", label: "آبان" },
  { value: "09", label: "آذر" },
  { value: "10", label: "دی" },
  { value: "11", label: "بهمن" },
  { value: "12", label: "اسفند" },
];

  export const birthDay = [
    { value: "01", label: "1" },
    { value: "02", label: "2" },
    { value: "03", label: "3" },
    { value: "04", label: "4" },
    { value: "05", label: "5" },
    { value: "06", label: "6" },
    { value: "07", label: "7" },
    { value: "08", label: "8" },
    { value: "09", label: "9" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
    { value: "17", label: "17" },
    { value: "18", label: "18" },
    { value: "19", label: "19" },
    { value: "20", label: "20" },
    { value: "21", label: "21" },
    { value: "22", label: "22" },
    { value: "23", label: "23" },
    { value: "24", label: "24" },
    { value: "25", label: "25" },
    { value: "26", label: "26" },
    { value: "27", label: "27" },
    { value: "28", label: "28" },
    { value: "29", label: "29" },
    { value: "30", label: "30" },
    { value: "31", label: "31" },
  ];

export const birthYear = [
  { value: "1390", label: "1390" },
  { value: "1389", label: "1389" },
  { value: "1388", label: "1388" },
  { value: "1387", label: "1387" },
  { value: "1386", label: "1386" },
  { value: "1385", label: "1385" },
  { value: "1384", label: "1384" },
  { value: "1383", label: "1383" },
  { value: "1382", label: "1382" },
  { value: "1381", label: "1381" },
  { value: "1380", label: "1380" },
  { value: "1379", label: "1379" },
  { value: "1378", label: "1378" },
  { value: "1377", label: "1377" },
  { value: "1376", label: "1376" },
  { value: "1375", label: "1375" },
  { value: "1374", label: "1374" },
  { value: "1373", label: "1373" },
  { value: "1372", label: "1372" },
  { value: "1371", label: "1371" },
  { value: "1370", label: "1370" },
  { value: "1369", label: "1369" },
  { value: "1368", label: "1368" },
  { value: "1367", label: "1367" },
  { value: "1366", label: "1366" },
  { value: "1365", label: "1365" },
  { value: "1364", label: "1364" },
  { value: "1363", label: "1363" },
  { value: "1362", label: "1362" },
  { value: "1361", label: "1361" },
  { value: "1360", label: "1360" },
  { value: "1359", label: "1359" },
  { value: "1358", label: "1358" },
  { value: "1357", label: "1357" },
  { value: "1356", label: "1356" },
  { value: "1355", label: "1355" },
  { value: "1354", label: "1354" },
  { value: "1353", label: "1353" },
  { value: "1352", label: "1352" },
  { value: "1351", label: "1351" },
  { value: "1350", label: "1350" },
  { value: "1349", label: "1349" },
  { value: "1348", label: "1348" },
  { value: "1347", label: "1347" },
  { value: "1346", label: "1346" },
  { value: "1345", label: "1345" },
  { value: "1344", label: "1344" },
  { value: "1343", label: "1343" },
  { value: "1342", label: "1342" },
  { value: "1341", label: "1341" },
  { value: "1340", label: "1340" },
  { value: "1339", label: "1339" },
  { value: "1338", label: "1338" },
  { value: "1337", label: "1337" },
  { value: "1336", label: "1336" },
  { value: "1335", label: "1335" },
  { value: "1334", label: "1334" },
  { value: "1333", label: "1333" },
  { value: "1332", label: "1332" },
  { value: "1331", label: "1331" },
  { value: "1330", label: "1330" }
];

export const TeachingGrades = [
  { label: "پیش‌دبستانی", value: "پیش‌دبستانی" },
  { label: "اول ابتدایی", value: "اول ابتدایی" },
  { label: "دوم ابتدایی", value: "دوم ابتدایی" },
  { label: "سوم ابتدایی", value: "سوم ابتدایی" },
  { label: "چهارم ابتدایی", value: "چهارم ابتدایی" },
  { label: "پنجم ابتدایی", value: "پنجم ابتدایی" },
  { label: "ششم ابتدایی", value: "ششم ابتدایی" },
  { label: "هفتم متوسطه اول", value: "هفتم متوسطه اول" },
  { label: "هشتم متوسطه اول", value: "هشتم متوسطه اول" },
  { label: "نهم متوسطه اول", value: "نهم متوسطه اول" },
  { label: "دهم متوسطه دوم", value: "دهم متوسطه دوم" },
  { label: "یازدهم متوسطه دوم", value: "یازدهم متوسطه دوم" },
  { label: "دوازدهم متوسطه دوم", value: "دوازدهم متوسطه دوم" },
  { label: "فنی و حرفه‌ای", value: "فنی و حرفه‌ای" },
  { label: "کاردانش", value: "کاردانش" },
  { label: "آموزش استثنایی", value: "آموزش استثنایی" },
  { label: "سایر", value: "سایر" },
];

export const TeachingExperience = [
  { label: "بدون سابقه تدریس", value: "بدون سابقه تدریس" },
  { label: "کمتر از ۱ سال", value: "کمتر از ۱ سال" },
  { label: "۱ تا ۳ سال", value: "۱ تا ۳ سال" },
  { label: "۳ تا ۵ سال", value: "۳ تا ۵ سال" },
  { label: "۵ تا ۱۰ سال", value: "۵ تا ۱۰ سال" },
  { label: "۱۰ تا ۱۵ سال", value: "۱۰ تا ۱۵ سال" },
  { label: "بیشتر از ۱۵ سال", value: "بیشتر از ۱۵ سال" },
];

export const Ostan = [
  { label: "آذربایجان شرقی", value: 1 },
  { label: "آذربایجان غربی", value: 2 },
  { label: "اردبیل", value: 3 },
  { label: "اصفهان", value: 4 },
  { label: "البرز", value: 5 },
  { label: "ایلام", value: 6 },
  { label: "بوشهر", value: 7 },
  { label: "تهران", value: 8 },
  { label: "چهارمحال وبختیاری", value: 9 },
  { label: "خراسان جنوبی", value: 10 },
  { label: "خراسان رضوی", value: 11 },
  { label: "خراسان شمالی", value: 12 },
  { label: "خوزستان", value: 13 },
  { label: "زنجان", value: 14 },
  { label: "سمنان", value: 15 },
  { label: "سیستان وبلوچستان", value: 16 },
  { label: "فارس", value: 17 },
  { label: "قزوین", value: 18 },
  { label: "قم", value: 19 },
  { label: "کردستان", value: 20 },
  { label: "کرمان", value: 21 },
  { label: "کرمانشاه", value: 22 },
  { label: "کهگیلویه وبویراحمد", value: 23 },
  { label: "گلستان", value: 24 },
  { label: "گیلان", value: 25 },
  { label: "لرستان", value: 26 },
  { label: "مازندران", value: 27 },
  { label: "مرکزی", value: 28 },
  { label: "هرمزگان", value: 29 },
  { label: "همدان", value: 30 },
  { label: "یزد", value: 31 },
];

export const Cities = [
  { label: "آبادان", value: 1, provinceId: 13, amarCode: 601 },
  { label: "آباده", value: 2, provinceId: 17, amarCode: 701 },
  { label: "آبدانان", value: 3, provinceId: 6, amarCode: 1606 },
  { label: "آبیک", value: 4, provinceId: 18, amarCode: 2604 },
  { label: "آذرشهر", value: 5, provinceId: 1, amarCode: 321 },
  { label: "آرادان", value: 6, provinceId: 15, amarCode: 2006 },
  { label: "آران وبیدگل", value: 7, provinceId: 4, amarCode: 1018 },
  { label: "آزادشهر", value: 8, provinceId: 24, amarCode: 2710 },
  { label: "آستارا", value: 9, provinceId: 25, amarCode: 101 },
  { label: "آستانه اشرفیه", value: 10, provinceId: 25, amarCode: 102 },
  { label: "آشتیان", value: 11, provinceId: 28, amarCode: 2 },
  { label: "آغاجاری", value: 12, provinceId: 13, amarCode: 626 },
  { label: "آق قلا", value: 13, provinceId: 24, amarCode: 2708 },
  { label: "آمل", value: 14, provinceId: 27, amarCode: 201 },
  { label: "آوج", value: 15, provinceId: 18, amarCode: 2606 },
  { label: "ابرکوه", value: 16, provinceId: 31, amarCode: 2107 },
  { label: "ابوموسی", value: 17, provinceId: 29, amarCode: 2201 },
  { label: "ابهر", value: 18, provinceId: 14, amarCode: 1901 },
  { label: "اراک", value: 19, provinceId: 28, amarCode: 1 },
  { label: "اردبیل", value: 20, provinceId: 3, amarCode: 2401 },
  { label: "اردستان", value: 21, provinceId: 4, amarCode: 1001 },
  { label: "اردکان", value: 22, provinceId: 31, amarCode: 2101 },
  { label: "اردل", value: 23, provinceId: 9, amarCode: 1405 },
  { label: "ارزوییه", value: 24, provinceId: 21, amarCode: 823 },
  { label: "ارسنجان", value: 25, provinceId: 17, amarCode: 717 },
  { label: "ارومیه", value: 26, provinceId: 2, amarCode: 401 },
  { label: "ازنا", value: 27, provinceId: 26, amarCode: 1507 },
  { label: "استهبان", value: 28, provinceId: 17, amarCode: 702 },
  { label: "اسدآباد", value: 29, provinceId: 30, amarCode: 1306 },
  { label: "اسفراین", value: 30, provinceId: 12, amarCode: 2801 },
  { label: "اسکو", value: 31, provinceId: 1, amarCode: 322 },
  { label: "اسلام آبادغرب", value: 32, provinceId: 22, amarCode: 501 },
  { label: "اسلامشهر", value: 33, provinceId: 8, amarCode: 2310 },
  { label: "اشتهارد", value: 34, provinceId: 5, amarCode: 3005 },
  { label: "اشکذر", value: 35, provinceId: 31, amarCode: 2108 },
  { label: "اشنویه", value: 36, provinceId: 2, amarCode: 413 },
  { label: "اصفهان", value: 37, provinceId: 4, amarCode: 1002 },
  { label: "اصلاندوز", value: 38, provinceId: 3, amarCode: 2411 },
  { label: "اقلید", value: 39, provinceId: 17, amarCode: 703 },
  { label: "البرز", value: 40, provinceId: 18, amarCode: 2605 },
  { label: "الیگودرز", value: 41, provinceId: 26, amarCode: 1501 },
  { label: "املش", value: 42, provinceId: 25, amarCode: 113 },
  { label: "امیدیه", value: 43, provinceId: 13, amarCode: 616 },
  { label: "انار", value: 44, provinceId: 21, amarCode: 820 },
  { label: "اندیکا", value: 45, provinceId: 13, amarCode: 621 },
  { label: "اندیمشک", value: 46, provinceId: 13, amarCode: 602 },
  { label: "اوز", value: 47, provinceId: 17, amarCode: 736 },
  { label: "اهر", value: 48, provinceId: 1, amarCode: 302 },
  { label: "اهواز", value: 49, provinceId: 13, amarCode: 603 },
  { label: "ایجرود", value: 50, provinceId: 14, amarCode: 1906 },
  { label: "ایذه", value: 51, provinceId: 13, amarCode: 604 },
  { label: "ایرانشهر", value: 52, provinceId: 16, amarCode: 1101 },
  { label: "ایلام", value: 53, provinceId: 6, amarCode: 1601 },
  { label: "ایوان", value: 54, provinceId: 6, amarCode: 1607 },
  { label: "بابل", value: 55, provinceId: 27, amarCode: 202 },
  { label: "بابلسر", value: 56, provinceId: 27, amarCode: 216 },
  { label: "باخرز", value: 57, provinceId: 11, amarCode: 937 },
  { label: "باشت", value: 58, provinceId: 23, amarCode: 1707 },
  { label: "باغ ملک", value: 59, provinceId: 13, amarCode: 615 },
  { label: "بافت", value: 60, provinceId: 21, amarCode: 801 },
  { label: "بافق", value: 61, provinceId: 31, amarCode: 2102 },
  { label: "بانه", value: 62, provinceId: 20, amarCode: 1201 },
  { label: "باوی", value: 63, provinceId: 13, amarCode: 624 },
  { label: "بجستان", value: 64, provinceId: 11, amarCode: 931 },
  { label: "بجنورد", value: 65, provinceId: 12, amarCode: 2802 },
  { label: "بختگان", value: 66, provinceId: 17, amarCode: 735 },
  { label: "بدره", value: 67, provinceId: 6, amarCode: 1610 },
  { label: "برخوار", value: 68, provinceId: 4, amarCode: 1022 },
  { label: "بردسکن", value: 69, provinceId: 11, amarCode: 923 },
  { label: "بردسیر", value: 70, provinceId: 21, amarCode: 810 },
  { label: "بروجرد", value: 71, provinceId: 26, amarCode: 1502 },
  { label: "بروجن", value: 72, provinceId: 9, amarCode: 1401 },
  { label: "بستان آباد", value: 73, provinceId: 1, amarCode: 313 },
  { label: "بستک", value: 74, provinceId: 29, amarCode: 2209 },
  { label: "بشاگرد", value: 75, provinceId: 29, amarCode: 2213 },
  { label: "بشرویه", value: 76, provinceId: 10, amarCode: 2908 },
  { label: "بم", value: 77, provinceId: 21, amarCode: 802 },
  { label: "بمپور", value: 78, provinceId: 16, amarCode: 1120 },
  { label: "بن", value: 79, provinceId: 9, amarCode: 1409 },
  { label: "بناب", value: 80, provinceId: 1, amarCode: 312 },
  { label: "بندرانزلی", value: 81, provinceId: 25, amarCode: 103 },
  { label: "بندرعباس", value: 82, provinceId: 29, amarCode: 2202 },
  { label: "بندرگز", value: 83, provinceId: 24, amarCode: 2701 },
  { label: "بندرلنگه", value: 84, provinceId: 29, amarCode: 2203 },
  { label: "بندرماهشهر", value: 85, provinceId: 13, amarCode: 605 },
  { label: "بو یین و میاندشت", value: 86, provinceId: 4, amarCode: 1024 },
  { label: "بوانات", value: 87, provinceId: 17, amarCode: 716 },
  { label: "بوشهر", value: 88, provinceId: 7, amarCode: 1801 },
  { label: "بوکان", value: 89, provinceId: 2, amarCode: 410 },
  { label: "بویراحمد", value: 90, provinceId: 23, amarCode: 1701 },
  { label: "بویین زهرا", value: 91, provinceId: 18, amarCode: 2601 },
  { label: "بهاباد", value: 92, provinceId: 31, amarCode: 2111 },
  { label: "بهار", value: 93, provinceId: 30, amarCode: 1307 },
  { label: "بهارستان", value: 94, provinceId: 8, amarCode: 2319 },
  { label: "بهبهان", value: 95, provinceId: 13, amarCode: 606 },
  { label: "بهشهر", value: 96, provinceId: 27, amarCode: 204 },
  { label: "بهمیی", value: 97, provinceId: 23, amarCode: 1705 },
  { label: "بیجار", value: 98, provinceId: 20, amarCode: 1202 },
  { label: "بیرجند", value: 99, provinceId: 10, amarCode: 2901 },
  { label: "بیضا", value: 100, provinceId: 17, amarCode: 731 },
  { label: "بیله سوار", value: 101, provinceId: 3, amarCode: 2402 },
  { label: "بینالود", value: 102, provinceId: 11, amarCode: 932 },
  { label: "پارس آباد", value: 103, provinceId: 3, amarCode: 2406 },
  { label: "پارسیان", value: 104, provinceId: 29, amarCode: 2211 },
  { label: "پاسارگاد", value: 105, provinceId: 17, amarCode: 723 },
  { label: "پاکدشت", value: 106, provinceId: 8, amarCode: 2313 },
  { label: "پاوه", value: 107, provinceId: 22, amarCode: 503 },
  { label: "پردیس", value: 108, provinceId: 8, amarCode: 2320 },
  { label: "پلدختر", value: 109, provinceId: 26, amarCode: 1508 },
  { label: "پلدشت", value: 110, provinceId: 2, amarCode: 415 },
  { label: "پیرانشهر", value: 111, provinceId: 2, amarCode: 402 },
  { label: "پیشوا", value: 112, provinceId: 8, amarCode: 2318 },
  { label: "تاکستان", value: 113, provinceId: 18, amarCode: 2602 },
  { label: "تایباد", value: 114, provinceId: 11, amarCode: 904 },
  { label: "تبریز", value: 115, provinceId: 1, amarCode: 303 },
  { label: "تربت جام", value: 116, provinceId: 11, amarCode: 906 },
  { label: "تربت حیدریه", value: 117, provinceId: 11, amarCode: 905 },
  { label: "ترکمن", value: 118, provinceId: 24, amarCode: 2702 },
  { label: "تفت", value: 119, provinceId: 31, amarCode: 2103 },
  { label: "تفتان", value: 120, provinceId: 16, amarCode: 1121 },
  { label: "تفرش", value: 121, provinceId: 28, amarCode: 3 },
  { label: "تکاب", value: 122, provinceId: 2, amarCode: 412 },
  { label: "تنکابن", value: 123, provinceId: 27, amarCode: 205 },
  { label: "تنگستان", value: 124, provinceId: 7, amarCode: 1802 },
  { label: "تویسرکان", value: 125, provinceId: 30, amarCode: 1301 },
  { label: "تهران", value: 126, provinceId: 8, amarCode: 2301 },
  { label: "تیران وکرون", value: 127, provinceId: 4, amarCode: 1019 },
  { label: "ثلاث باباجانی", value: 128, provinceId: 22, amarCode: 512 },
  { label: "جاجرم", value: 129, provinceId: 12, amarCode: 2803 },
  { label: "جاسک", value: 130, provinceId: 29, amarCode: 2206 },
  { label: "جغتای", value: 131, provinceId: 11, amarCode: 934 },
  { label: "جلفا", value: 132, provinceId: 1, amarCode: 319 },
  { label: "جم", value: 133, provinceId: 7, amarCode: 1809 },
  { label: "جوانرود", value: 134, provinceId: 22, amarCode: 509 },
  { label: "جویبار", value: 135, provinceId: 27, amarCode: 221 },
  { label: "جوین", value: 136, provinceId: 11, amarCode: 936 },
  { label: "جهرم", value: 137, provinceId: 17, amarCode: 704 },
  { label: "جیرفت", value: 138, provinceId: 21, amarCode: 803 },
  { label: "چادگان", value: 139, provinceId: 4, amarCode: 1020 },
  { label: "چاراویماق", value: 140, provinceId: 1, amarCode: 323 },
  { label: "چالدران", value: 141, provinceId: 2, amarCode: 414 },
  { label: "چالوس", value: 142, provinceId: 27, amarCode: 220 },
  { label: "چاه بهار", value: 143, provinceId: 16, amarCode: 1102 },
  { label: "چایپاره", value: 144, provinceId: 2, amarCode: 416 },
  { label: "چرام", value: 145, provinceId: 23, amarCode: 1706 },
  { label: "چرداول", value: 146, provinceId: 6, amarCode: 1604 },
  { label: "چگنی", value: 147, provinceId: 26, amarCode: 1510 },
  { label: "چناران", value: 148, provinceId: 11, amarCode: 918 },
  { label: "حاجی اباد", value: 149, provinceId: 29, amarCode: 2208 },
  { label: "حمیدیه", value: 150, provinceId: 13, amarCode: 625 }, { label: "خاتم", value: 151, provinceId: 31, amarCode: 2109 },
  { label: "خاش", value: 152, provinceId: 16, amarCode: 1103 },
  { label: "خانمیرزا", value: 153, provinceId: 9, amarCode: 1410 },
  { label: "خداآفرین", value: 154, provinceId: 1, amarCode: 326 },
  { label: "خدابنده", value: 155, provinceId: 14, amarCode: 1903 },
  { label: "خرامه", value: 156, provinceId: 17, amarCode: 729 },
  { label: "خرم آباد", value: 157, provinceId: 26, amarCode: 1503 },
  { label: "خرم بید", value: 158, provinceId: 17, amarCode: 718 },
  { label: "خرمدره", value: 159, provinceId: 14, amarCode: 1907 },
  { label: "خرمشهر", value: 160, provinceId: 13, amarCode: 607 },
  { label: "خفر", value: 161, provinceId: 17, amarCode: 734 },
  { label: "خلخال", value: 162, provinceId: 3, amarCode: 2403 },
  { label: "خلیل آباد", value: 163, provinceId: 11, amarCode: 929 },
  { label: "خمیر", value: 164, provinceId: 29, amarCode: 2210 },
  { label: "خمین", value: 165, provinceId: 28, amarCode: 4 },
  { label: "خمینی شهر", value: 166, provinceId: 4, amarCode: 1003 },
  { label: "خنج", value: 167, provinceId: 17, amarCode: 724 },
  { label: "خنداب", value: 168, provinceId: 28, amarCode: 12 },
  { label: "خواف", value: 169, provinceId: 11, amarCode: 919 },
  { label: "خوانسار", value: 170, provinceId: 4, amarCode: 1004 },
  { label: "خور و بیابانک", value: 171, provinceId: 4, amarCode: 1023 },
  { label: "خوسف", value: 172, provinceId: 10, amarCode: 2910 },
  { label: "خوشاب", value: 173, provinceId: 11, amarCode: 938 },
  { label: "خوی", value: 174, provinceId: 2, amarCode: 403 },
  { label: "داراب", value: 175, provinceId: 17, amarCode: 705 },
  { label: "دالاهو", value: 176, provinceId: 22, amarCode: 513 },
  { label: "دامغان", value: 177, provinceId: 15, amarCode: 2001 },
  { label: "داورزن", value: 178, provinceId: 11, amarCode: 939 },
  { label: "درگز", value: 179, provinceId: 11, amarCode: 907 },
  { label: "درگزین", value: 180, provinceId: 30, amarCode: 1310 },
  { label: "درمیان", value: 181, provinceId: 10, amarCode: 2902 },
  { label: "دره شهر", value: 182, provinceId: 6, amarCode: 1602 },
  { label: "دزفول", value: 183, provinceId: 13, amarCode: 608 },
  { label: "دشت آزادگان", value: 184, provinceId: 13, amarCode: 609 },
  { label: "دشتستان", value: 185, provinceId: 7, amarCode: 1803 },
  { label: "دشتی", value: 186, provinceId: 7, amarCode: 1804 },
  { label: "دشتیاری", value: 187, provinceId: 16, amarCode: 1122 },
  { label: "دلفان", value: 188, provinceId: 26, amarCode: 1504 },
  { label: "دلگان", value: 189, provinceId: 16, amarCode: 1112 },
  { label: "دلیجان", value: 190, provinceId: 28, amarCode: 5 },
  { label: "دماوند", value: 191, provinceId: 8, amarCode: 2302 },
  { label: "دنا", value: 192, provinceId: 23, amarCode: 1704 },
  { label: "دورود", value: 193, provinceId: 26, amarCode: 1505 },
  { label: "دهاقان", value: 194, provinceId: 4, amarCode: 1021 },
  { label: "دهگلان", value: 195, provinceId: 20, amarCode: 1210 },
  { label: "دهلران", value: 196, provinceId: 6, amarCode: 1603 },
  { label: "دیر", value: 197, provinceId: 7, amarCode: 1805 },
  { label: "دیلم", value: 198, provinceId: 7, amarCode: 1808 },
  { label: "دیواندره", value: 199, provinceId: 20, amarCode: 1207 },
  { label: "رابر", value: 200, provinceId: 21, amarCode: 818 }, { label: "راز و جرگلان", value: 201, provinceId: 12, amarCode: 2808 },
  { label: "راسک", value: 202, provinceId: 16, amarCode: 1108 },
  { label: "رامسر", value: 203, provinceId: 27, amarCode: 206 },
  { label: "رامشیر", value: 204, provinceId: 13, amarCode: 619 },
  { label: "رامهرمز", value: 205, provinceId: 13, amarCode: 610 },
  { label: "رامیان", value: 206, provinceId: 24, amarCode: 2711 },
  { label: "راور", value: 207, provinceId: 21, amarCode: 811 },
  { label: "رباط کریم", value: 208, provinceId: 8, amarCode: 2312 },
  { label: "رزن", value: 209, provinceId: 30, amarCode: 1308 },
  { label: "رستم", value: 210, provinceId: 17, amarCode: 726 },
  { label: "رشت", value: 211, provinceId: 25, amarCode: 105 },
  { label: "رشتخوار", value: 212, provinceId: 11, amarCode: 927 },
  { label: "رضوانشهر", value: 213, provinceId: 25, amarCode: 114 },
  { label: "رفسنجان", value: 214, provinceId: 21, amarCode: 804 },
  { label: "روانسر", value: 215, provinceId: 22, amarCode: 514 },
  { label: "رودان", value: 216, provinceId: 29, amarCode: 2207 },
  { label: "رودبار", value: 217, provinceId: 25, amarCode: 106 },
  { label: "رودبارجنوب", value: 218, provinceId: 21, amarCode: 815 },
  { label: "رودسر", value: 219, provinceId: 25, amarCode: 107 },
  { label: "رومشکان", value: 220, provinceId: 26, amarCode: 1511 },
  { label: "ری", value: 221, provinceId: 8, amarCode: 2303 },
  { label: "ریگان", value: 222, provinceId: 21, amarCode: 817 },
  { label: "زابل", value: 223, provinceId: 16, amarCode: 1104 },
  { label: "زاوه", value: 224, provinceId: 11, amarCode: 935 },
  { label: "زاهدان", value: 225, provinceId: 16, amarCode: 1105 },
  { label: "زرقان", value: 226, provinceId: 17, amarCode: 730 },
  { label: "زرند", value: 227, provinceId: 21, amarCode: 805 },
  { label: "زرندیه", value: 228, provinceId: 28, amarCode: 10 },
  { label: "زرین دشت", value: 229, provinceId: 17, amarCode: 719 },
  { label: "زنجان", value: 230, provinceId: 14, amarCode: 1904 },
  { label: "زهک", value: 231, provinceId: 16, amarCode: 1110 },
  { label: "زیرکوه", value: 232, provinceId: 10, amarCode: 2909 },
  { label: "ساری", value: 233, provinceId: 27, amarCode: 207 },
  { label: "سامان", value: 234, provinceId: 9, amarCode: 1408 },
  { label: "ساوجبلاغ", value: 235, provinceId: 5, amarCode: 3002 },
  { label: "ساوه", value: 236, provinceId: 28, amarCode: 6 },
  { label: "سبزوار", value: 237, provinceId: 11, amarCode: 908 },
  { label: "سپیدان", value: 238, provinceId: 17, amarCode: 706 },
  { label: "سراب", value: 239, provinceId: 1, amarCode: 305 },
  { label: "سراوان", value: 240, provinceId: 16, amarCode: 1106 },
  { label: "سرایان", value: 241, provinceId: 10, amarCode: 2906 },
  { label: "سرباز", value: 242, provinceId: 16, amarCode: 1123 },
  { label: "سربیشه", value: 243, provinceId: 10, amarCode: 2903 },
  { label: "سرپل ذهاب", value: 244, provinceId: 22, amarCode: 504 },
  { label: "سرچهان", value: 245, provinceId: 17, amarCode: 732 },
  { label: "سرخس", value: 246, provinceId: 11, amarCode: 920 },
  { label: "سرخه", value: 247, provinceId: 15, amarCode: 2008 },
  { label: "سردشت", value: 248, provinceId: 2, amarCode: 404 },
  { label: "سرعین", value: 249, provinceId: 3, amarCode: 2410 },
  { label: "سروآباد", value: 250, provinceId: 20, amarCode: 1209 }, { label: "سروستان", value: 251, provinceId: 17, amarCode: 725 },
  { label: "سقز", value: 252, provinceId: 20, amarCode: 1203 },
  { label: "سلسله", value: 253, provinceId: 26, amarCode: 1509 },
  { label: "سلطانیه", value: 254, provinceId: 14, amarCode: 1910 },
  { label: "سلماس", value: 255, provinceId: 2, amarCode: 405 },
  { label: "سمنان", value: 256, provinceId: 15, amarCode: 2002 },
  { label: "سمیرم", value: 257, provinceId: 4, amarCode: 1005 },
  { label: "سنقر", value: 258, provinceId: 22, amarCode: 505 },
  { label: "سنندج", value: 259, provinceId: 20, amarCode: 1204 },
  { label: "سوادکوه", value: 260, provinceId: 27, amarCode: 208 },
  { label: "سوادکوه شمالی", value: 261, provinceId: 27, amarCode: 227 },
  { label: "سیاهکل", value: 262, provinceId: 25, amarCode: 115 },
  { label: "سیب و سوران", value: 263, provinceId: 16, amarCode: 1114 },
  { label: "سیرجان", value: 264, provinceId: 21, amarCode: 806 },
  { label: "سیروان", value: 265, provinceId: 6, amarCode: 1609 },
  { label: "سیریک", value: 266, provinceId: 29, amarCode: 2212 },
  { label: "سیمرغ", value: 267, provinceId: 27, amarCode: 226 },
  { label: "شادگان", value: 268, provinceId: 13, amarCode: 611 },
  { label: "شازند", value: 269, provinceId: 28, amarCode: 7 },
  { label: "شاهرود", value: 270, provinceId: 15, amarCode: 2003 },
  { label: "شاهین دژ", value: 271, provinceId: 2, amarCode: 411 },
  { label: "شاهین شهرومیمه", value: 272, provinceId: 4, amarCode: 1016 },
  { label: "شبستر", value: 273, provinceId: 1, amarCode: 314 },
  { label: "شفت", value: 274, provinceId: 25, amarCode: 112 },
  { label: "شمیرانات", value: 275, provinceId: 8, amarCode: 2304 },
  { label: "شوش", value: 276, provinceId: 13, amarCode: 614 },
  { label: "شوشتر", value: 277, provinceId: 13, amarCode: 612 },
  { label: "شوط", value: 278, provinceId: 2, amarCode: 417 },
  { label: "شهربابک", value: 279, provinceId: 21, amarCode: 807 },
  { label: "شهرضا", value: 280, provinceId: 4, amarCode: 1009 },
  { label: "شهرکرد", value: 281, provinceId: 9, amarCode: 1402 },
  { label: "شهریار", value: 282, provinceId: 8, amarCode: 2309 },
  { label: "شیراز", value: 283, provinceId: 17, amarCode: 707 },
  { label: "شیروان", value: 284, provinceId: 12, amarCode: 2804 },
  { label: "صالح آباد", value: 285, provinceId: 11, amarCode: 940 },
  { label: "صحنه", value: 286, provinceId: 22, amarCode: 510 },
  { label: "صومعه سرا", value: 287, provinceId: 25, amarCode: 108 },
  { label: "طارم", value: 288, provinceId: 14, amarCode: 1908 },
  { label: "طالقان", value: 289, provinceId: 5, amarCode: 3004 },
  { label: "طبس", value: 290, provinceId: 10, amarCode: 2911 },
  { label: "طوالش", value: 291, provinceId: 25, amarCode: 104 },
  { label: "عباس آباد", value: 292, provinceId: 27, amarCode: 224 },
  { label: "عجب شیر", value: 293, provinceId: 1, amarCode: 325 },
  { label: "عسلویه", value: 294, provinceId: 7, amarCode: 1810 },
  { label: "علی آباد کتول", value: 295, provinceId: 24, amarCode: 2703 },
  { label: "عنبرآباد", value: 296, provinceId: 21, amarCode: 812 },
  { label: "فارسان", value: 297, provinceId: 9, amarCode: 1403 },
  { label: "فاروج", value: 298, provinceId: 12, amarCode: 2805 },
  { label: "فاریاب", value: 299, provinceId: 21, amarCode: 822 },
  { label: "فامنین", value: 300, provinceId: 30, amarCode: 1309 }, { label: "فراشبند", value: 301, provinceId: 17, amarCode: 722 },
  { label: "فراهان", value: 302, provinceId: 28, amarCode: 13 },
  { label: "فردوس", value: 303, provinceId: 10, amarCode: 2907 },
  { label: "فردیس", value: 304, provinceId: 5, amarCode: 3006 },
  { label: "فریدن", value: 305, provinceId: 4, amarCode: 1006 },
  { label: "فریدونشهر", value: 306, provinceId: 4, amarCode: 1007 },
  { label: "فریدونکنار", value: 307, provinceId: 27, amarCode: 223 },
  { label: "فریمان", value: 308, provinceId: 11, amarCode: 922 },
  { label: "فسا", value: 309, provinceId: 17, amarCode: 708 },
  { label: "فلاورجان", value: 310, provinceId: 4, amarCode: 1008 },
  { label: "فنوج", value: 311, provinceId: 16, amarCode: 1119 },
  { label: "فومن", value: 312, provinceId: 25, amarCode: 109 },
  { label: "فهرج", value: 313, provinceId: 21, amarCode: 819 },
  { label: "فیروزآباد", value: 314, provinceId: 17, amarCode: 709 },
  { label: "فیروزکوه", value: 315, provinceId: 8, amarCode: 2314 },
  { label: "فیروزه", value: 316, provinceId: 11, amarCode: 933 },
  { label: "قایم شهر", value: 317, provinceId: 27, amarCode: 210 },
  { label: "قاینات", value: 318, provinceId: 10, amarCode: 2904 },
  { label: "قدس", value: 319, provinceId: 8, amarCode: 2316 },
  { label: "قرچک", value: 320, provinceId: 8, amarCode: 2321 },
  { label: "قروه", value: 321, provinceId: 20, amarCode: 1205 },
  { label: "قزوین", value: 322, provinceId: 18, amarCode: 2603 },
  { label: "قشم", value: 323, provinceId: 29, amarCode: 2204 },
  { label: "قصرشیرین", value: 324, provinceId: 22, amarCode: 506 },
  { label: "قصرقند", value: 325, provinceId: 16, amarCode: 1118 },
  { label: "قلعه گنج", value: 326, provinceId: 21, amarCode: 816 },
  { label: "قم", value: 327, provinceId: 19, amarCode: 2501 },
  { label: "قوچان", value: 328, provinceId: 11, amarCode: 913 },
  { label: "قیروکارزین", value: 329, provinceId: 17, amarCode: 720 },
  { label: "کارون", value: 330, provinceId: 13, amarCode: 627 },
  { label: "کازرون", value: 331, provinceId: 17, amarCode: 710 },
  { label: "کاشان", value: 332, provinceId: 4, amarCode: 1010 },
  { label: "کاشمر", value: 333, provinceId: 11, amarCode: 914 },
  { label: "کامیاران", value: 334, provinceId: 20, amarCode: 1208 },
  { label: "کبودرآهنگ", value: 335, provinceId: 30, amarCode: 1305 },
  { label: "کرج", value: 336, provinceId: 5, amarCode: 3001 },
  { label: "کردکوی", value: 337, provinceId: 24, amarCode: 2704 },
  { label: "کرمان", value: 338, provinceId: 21, amarCode: 808 },
  { label: "کرمانشاه", value: 339, provinceId: 22, amarCode: 502 },
  { label: "کلات", value: 340, provinceId: 11, amarCode: 928 },
  { label: "کلاردشت", value: 341, provinceId: 27, amarCode: 228 },
  { label: "کلاله", value: 342, provinceId: 24, amarCode: 2709 },
  { label: "کلیبر", value: 343, provinceId: 1, amarCode: 315 },
  { label: "کمیجان", value: 344, provinceId: 28, amarCode: 11 },
  { label: "کنارک", value: 345, provinceId: 16, amarCode: 1109 },
  { label: "کنگان", value: 346, provinceId: 7, amarCode: 1806 },
  { label: "کنگاور", value: 347, provinceId: 22, amarCode: 507 },
  { label: "کوار", value: 348, provinceId: 17, amarCode: 728 },
  { label: "کوثر", value: 349, provinceId: 3, amarCode: 2407 },
  { label: "کوه چنار", value: 350, provinceId: 17, amarCode: 733 }, { label: "کوهبنان", value: 351, provinceId: 21, amarCode: 814 },
  { label: "کوهدشت", value: 352, provinceId: 26, amarCode: 1506 },
  { label: "کوهرنگ", value: 353, provinceId: 9, amarCode: 1406 },
  { label: "کوهسرخ", value: 354, provinceId: 11, amarCode: 941 },
  { label: "کهگیلویه", value: 355, provinceId: 23, amarCode: 1702 },
  { label: "کهنوج", value: 356, provinceId: 21, amarCode: 809 },
  { label: "کیار", value: 357, provinceId: 9, amarCode: 1407 },
  { label: "گالیکش", value: 358, provinceId: 24, amarCode: 2714 },
  { label: "گتوند", value: 359, provinceId: 13, amarCode: 620 },
  { label: "گچساران", value: 360, provinceId: 23, amarCode: 1703 },
  { label: "گراش", value: 361, provinceId: 17, amarCode: 727 },
  { label: "گرگان", value: 362, provinceId: 24, amarCode: 2705 },
  { label: "گرمسار", value: 363, provinceId: 15, amarCode: 2004 },
  { label: "گرمه", value: 364, provinceId: 12, amarCode: 2807 },
  { label: "گرمی", value: 365, provinceId: 3, amarCode: 2405 },
  { label: "گلپایگان", value: 366, provinceId: 4, amarCode: 1011 },
  { label: "گلوگاه", value: 367, provinceId: 27, amarCode: 222 },
  { label: "گمیشان", value: 368, provinceId: 24, amarCode: 2713 },
  { label: "گناباد", value: 369, provinceId: 11, amarCode: 915 },
  { label: "گناوه", value: 370, provinceId: 7, amarCode: 1807 },
  { label: "گنبدکاووس", value: 371, provinceId: 24, amarCode: 2706 },
  { label: "گیلانغرب", value: 372, provinceId: 22, amarCode: 508 },
  { label: "لارستان", value: 373, provinceId: 17, amarCode: 711 },
  { label: "لالی", value: 374, provinceId: 13, amarCode: 617 },
  { label: "لامرد", value: 375, provinceId: 17, amarCode: 715 },
  { label: "لاهیجان", value: 376, provinceId: 25, amarCode: 111 },
  { label: "لردگان", value: 377, provinceId: 9, amarCode: 1404 },
  { label: "لنجان", value: 378, provinceId: 4, amarCode: 1012 },
  { label: "لنده", value: 379, provinceId: 23, amarCode: 1708 },
  { label: "لنگرود", value: 380, provinceId: 25, amarCode: 110 },
  { label: "مارگون", value: 381, provinceId: 23, amarCode: 1709 },
  { label: "ماسال", value: 382, provinceId: 25, amarCode: 116 },
  { label: "ماکو", value: 383, provinceId: 2, amarCode: 406 },
  { label: "مانه وسملقان", value: 384, provinceId: 12, amarCode: 2806 },
  { label: "ماهنشان", value: 385, provinceId: 14, amarCode: 1909 },
  { label: "مبارکه", value: 386, provinceId: 4, amarCode: 1017 },
  { label: "محلات", value: 387, provinceId: 28, amarCode: 9 },
  { label: "محمودآباد", value: 388, provinceId: 27, amarCode: 218 },
  { label: "مراغه", value: 389, provinceId: 1, amarCode: 306 },
  { label: "مراوه تپه", value: 390, provinceId: 24, amarCode: 2712 },
  { label: "مرند", value: 391, provinceId: 1, amarCode: 307 },
  { label: "مرودشت", value: 392, provinceId: 17, amarCode: 712 },
  { label: "مریوان", value: 393, provinceId: 20, amarCode: 1206 },
  { label: "مسجدسلیمان", value: 394, provinceId: 13, amarCode: 613 },
  { label: "مشگین شهر", value: 395, provinceId: 3, amarCode: 2404 },
  { label: "مشهد", value: 396, provinceId: 11, amarCode: 916 },
  { label: "ملارد", value: 397, provinceId: 8, amarCode: 2317 },
  { label: "ملایر", value: 398, provinceId: 30, amarCode: 1302 },
  { label: "ملکان", value: 399, provinceId: 1, amarCode: 320 },
  { label: "ملکشاهی", value: 400, provinceId: 6, amarCode: 1608 }, { label: "ممسنی", value: 401, provinceId: 17, amarCode: 713 },
  { label: "منوجان", value: 402, provinceId: 21, amarCode: 813 },
  { label: "مه ولات", value: 403, provinceId: 11, amarCode: 930 },
  { label: "مهاباد", value: 404, provinceId: 2, amarCode: 407 },
  { label: "مهدی شهر", value: 405, provinceId: 15, amarCode: 2005 },
  { label: "مهر", value: 406, provinceId: 17, amarCode: 721 },
  { label: "مهران", value: 407, provinceId: 6, amarCode: 1605 },
  { label: "مهرستان", value: 408, provinceId: 16, amarCode: 1113 },
  { label: "مهریز", value: 409, provinceId: 31, amarCode: 2104 },
  { label: "میامی", value: 410, provinceId: 15, amarCode: 2007 },
  { label: "میاندوآب", value: 411, provinceId: 2, amarCode: 408 },
  { label: "میاندورود", value: 412, provinceId: 27, amarCode: 225 },
  { label: "میانه", value: 413, provinceId: 1, amarCode: 310 },
  { label: "میبد", value: 414, provinceId: 31, amarCode: 2106 },
  { label: "میرجاوه", value: 415, provinceId: 16, amarCode: 1117 },
  { label: "میناب", value: 416, provinceId: 29, amarCode: 2205 },
  { label: "مینودشت", value: 417, provinceId: 24, amarCode: 2707 },
  { label: "نایین", value: 418, provinceId: 4, amarCode: 1013 },
  { label: "نجف آباد", value: 419, provinceId: 4, amarCode: 1014 },
  { label: "نرماشیر", value: 420, provinceId: 21, amarCode: 821 },
  { label: "نطنز", value: 421, provinceId: 4, amarCode: 1015 },
  { label: "نظرآباد", value: 422, provinceId: 5, amarCode: 3003 },
  { label: "نقده", value: 423, provinceId: 2, amarCode: 409 },
  { label: "نکا", value: 424, provinceId: 27, amarCode: 219 },
  { label: "نمین", value: 425, provinceId: 3, amarCode: 2408 },
  { label: "نور", value: 426, provinceId: 27, amarCode: 214 },
  { label: "نوشهر", value: 427, provinceId: 27, amarCode: 215 },
  { label: "نهاوند", value: 428, provinceId: 30, amarCode: 1303 },
  { label: "نهبندان", value: 429, provinceId: 10, amarCode: 2905 },
  { label: "نی ریز", value: 430, provinceId: 17, amarCode: 714 },
  { label: "نیر", value: 431, provinceId: 3, amarCode: 2409 },
  { label: "نیشابور", value: 432, provinceId: 11, amarCode: 917 },
  { label: "نیک شهر", value: 433, provinceId: 16, amarCode: 1107 },
  { label: "نیمروز", value: 434, provinceId: 16, amarCode: 1115 },
  { label: "ورامین", value: 435, provinceId: 8, amarCode: 2306 },
  { label: "ورزقان", value: 436, provinceId: 1, amarCode: 324 },
  { label: "هامون", value: 437, provinceId: 16, amarCode: 1116 },
  { label: "هرسین", value: 438, provinceId: 22, amarCode: 511 },
  { label: "هریس", value: 439, provinceId: 1, amarCode: 316 },
  { label: "هشترود", value: 440, provinceId: 1, amarCode: 311 },
  { label: "هفتکل", value: 441, provinceId: 13, amarCode: 622 },
  { label: "هلیلان", value: 442, provinceId: 6, amarCode: 1611 },
  { label: "همدان", value: 443, provinceId: 30, amarCode: 1304 },
  { label: "هندیجان", value: 444, provinceId: 13, amarCode: 618 },
  { label: "هوراند", value: 445, provinceId: 1, amarCode: 327 },
  { label: "هویزه", value: 446, provinceId: 13, amarCode: 623 },
  { label: "هیرمند", value: 447, provinceId: 16, amarCode: 1111 },
  { label: "یزد", value: 448, provinceId: 31, amarCode: 2105 },
];